import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'iv-live-number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent implements OnInit {

  @Input() valueAttribute: string;
  @Input() label = null;
  @Input() cssClass = '';
  @Output() selectedDataChange = new EventEmitter<any>();

  constructor() {
  }

  private _selectedData: any;

  get selectedData(): any {
    return this._selectedData;
  }

  @Input() set selectedData(value: any) {
    this._selectedData = value;
  }

  ngOnInit() {
  }

  getValue(selectedData): string {
    if (selectedData === null) {
      return '';
    }
    if (typeof selectedData === 'object') {
      return String(selectedData[this.valueAttribute]);
    }
    return String(selectedData);
  }

  increaseCenter() {
    this.selectedData++;
    this.selectedDataChange.emit(this.selectedData);
  }

  decreaseCenter() {
    this.selectedData--;
    this.selectedDataChange.emit(this.selectedData);
  }


  onChange() {
    this.selectedDataChange.emit(this.selectedData);
  }
}
